<div class="community">
  <h1>Welcome to the 7N community</h1>
  <p class="baseline_large">The beta version of the 7N community is now available to all existing consultants of 7N. We
    will, over the next 6 month, integrate it into the platform and add additional features. For now you will have to
    click the button below and open the community in a new tab. Have bugs, ideas or feedback - please let us know. </p>
  <div (click)="open()" class="btn btn-dark">
    <p>Open community</p>
  </div>
</div>
